/* eslint-disable react/forbid-prop-types,react/destructuring-assignment,max-len */
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect, shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import RouteWithLayout from './RouteWithLayout';
import { getUserRole } from '../../utils/CommonUtils';
import { RolEnum } from '../Issuance/components/Payment/Enums';

export const foundPathInMenus = (path, menus) => {
  const joinedMenus = menus.map((menu) => menu.menus).flat();
  return joinedMenus.some((menu) => menu.url === path);
};

/**
 * Allow retrieving the correct route to users with specific roles.
 * */
const CustomRoute = ({ condition = '', ...props }) => {
  const login = useSelector((state) => state.login, shallowEqual);
  const role = getUserRole(login);

  switch (condition) {
    case 'private':
      // exception only for this inner path
      if (login.signedIn && props.path === '/issuance' && role !== RolEnum.ReporterUnified) {
        return <RouteWithLayout {...props} />;
      }
      if (login.signedIn && foundPathInMenus(props.path, login.menus)) {
        return <RouteWithLayout {...props} />;
      }
      return <Redirect to="/quotation" />;
    case 'public':
      return <RouteWithLayout {...props} />;
    default:
      return <Route {...props} />;
  }
};

const mapStateToProps = ({ login }) => ({ login });

CustomRoute.propTypes = {
  condition: PropTypes.string,
  login: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
  null,
)(CustomRoute);
